import React from "react";
import { Button } from "reactstrap";

const AmenitiesTabs = ({ tab, setTab }) => {
  return (
    <div className="amenity-tabs mb-3">
      <button className={tab==="active"?"active":""} onClick={()=>setTab("active")}>
        Active
      </button>

      <button className={tab==="inactive"?"active":""} onClick={()=>setTab("inactive")}>
        Inactive
      </button>

      <button className={tab==="deleted"?"active":""} onClick={()=>setTab("deleted")}>
        Deleted
      </button>

      <span
        className={`tab-indicator ${
          tab==="active"
            ? "active-pos"
            : tab==="inactive"
            ? "inactive-pos"
            : "deleted-pos"
        }`}
      />
    </div>
  );
};

export default AmenitiesTabs;